import { Grid2 as Grid, MenuItem } from "@mui/material"
import Button from "@mui/material/Button"
import { Field, Formik } from "formik"
import { useMemo } from "react"
import * as yup from "yup"
import { User } from "../../types"
import { transformErrorForForm } from "../../utils/utils"
import { FormInDialogProps } from "../DialogForm"
import { useTranslation } from "react-i18next"
import { FormikSelect } from "./formsHelpers"


export default function UtenteForm({ item, save, ref }: FormInDialogProps<User>) {
  const { t } = useTranslation()
  const initialValues = useMemo(() => {
    return (
      item ?? {
        display: "",
      }
    )
  }, [item])

  const schema = useMemo(
    () =>
      yup.object().shape({
        display: yup.string()
      }),
    [t]
  )

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as User).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={12}>
                <Field
                  component={FormikSelect}
                  name="display"
                  label={t("user.display")}
                  autoFocus
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  placeholder={"auto"}
                >
                  <MenuItem value={""}>{t("auto")}</MenuItem>
                  <MenuItem value={"tablet"}>tablet</MenuItem>
                  <MenuItem value={"mobile"}>mobile</MenuItem>
                </Field>
                
              </Grid>
              
            </Grid>
            

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
